const env = process.env['NODE_ENV'];

export const isProduction = env === 'production';
export const isDevelopment = env === 'development';
export const isTest = env === 'test';

/**
 * default maximum file size upload in bytes
 */
export const MAX_UPLOAD_FILE_SIZE = 5242880;

/**
 * Maximum file size error message
 */
export const EXCEEDING_FILE_SIZE_EROR_MESSAGE =
  'Your file is too large. The maximum upload size is 5MB';

/**
 * http status code
 */
export const STATUS_CODES = {
  OK: 200,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500
};

/**
 * Date constants values
 */
export const Dates = {
  /**
   * Char seperator between the date different sections (day, month, year)
   */
  DATE_DIVIDER_CHAR: '/',

  /**
   * Date format for full mode
   */
  FULL_DATE_FORMAT: 'DD/MM/YYYY',

  /**
   * Date format used by the Duet Datepicker - the format under the hood for our DatePicker component
   */
  DUET_DATE_FORMAT: 'YYYY-MM-DD',

  /**
   * Date format for partial mode
   */
  MONTH_YEAR_FORMAT: 'MM/YYYY',

  /**
   * Display date format in UX
   */
  DISPLAY_FORMAT: 'DD MMMM YYYY'
};

/**
 * Number of ms to wait before invoking a function callback
 */
export const INPUT_DELAY = 250;

/**
 * State options
 */
export const stateOptions: { label: string; value: string }[] = [
  {
    label: 'ACT',
    value: 'ACT'
  },
  {
    label: 'NSW',
    value: 'NSW'
  },
  {
    label: 'NT',
    value: 'NT'
  },
  {
    label: 'QLD',
    value: 'QLD'
  },
  {
    label: 'SA',
    value: 'SA'
  },
  {
    label: 'TAS',
    value: 'TAS'
  },
  {
    label: 'VIC',
    value: 'VIC'
  },
  {
    label: 'WA',
    value: 'WA'
  }
];
